import styled from 'styled-components';
import { colors } from '../colors';

const HamburgerMenu = styled.div`
	display: flex;
	align-items: center;
	font-size: 16px;
	position: relative;
	color: ${colors.White};
	transition: ease-in all 0.4s;
	margin-right: auto;
	cursor: pointer;
`;
export default HamburgerMenu;
